import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import Waypoint from 'react-waypoint';
import {Spinner} from '../../components/spinners/Spinner'
import formatNotification from './NotificationFormatter';
import notificationsStore from './WorkflowNotificationsStore'
import PropTypes from "prop-types";
import {tagPropType} from "reactstrap/lib/utils";

const propTypes = {
  foldyLayout: PropTypes.bool // We change the classnames and structure of the bell icon in the header a bit for the new layout
};

export const WorkflowNotificationList = observer(class WorkflowNotificationList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { open: false, hadChromeDome: false };
    this.componentRef = React.createRef();
    this.listRef = React.createRef();
  }

  componentWillMount() {
    document.addEventListener("mouseup", this.clickOutside, false);
    if(!notificationsStore.isInitializing) {
      notificationsStore.init();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.clickOutside);
  }

  clickOutside = (e) => {
    if (this.componentRef.current && !this.componentRef.current.contains(e.target) && this.state.open) {
      this.closeList();
    }
  };

  render() {
    const {foldyLayout} = this.props;

    return <div className="d-flex align-items-center">
      {foldyLayout ? <a id="notification-trigger" className="header-button" data-analyticsclick="Appbar Notification List" onClick={() => this.state.open ? this.closeList() : this.openList() }>
        <div className="d-flex align-items-center">
          <i className="fas fa-bell d-flex justify-content-center m-auto" />
        </div>
      </a> : <span className={"nav-link d-flex header-link-notification h-100" + (this.state.open ? 'open' : '')}>
      <span id="notification-trigger" className="d-flex align-items-center">
        <i className="fas fa-bell notification-toggle-btn d-flex" onClick={() => this.state.open ? this.closeList() : this.openList() }></i>
        <span className={"alert-count" + (notificationsStore.countUnread === 0 ? ' d-none' : '')}>{ notificationsStore.unreadBadge }</span>
      </span>
      </span>}
      <Popover popperClassName="notifications-popper" positionFixed={true} fade={false} placement="top-end" className="notification-popover" isOpen={this.state.open} target="notification-trigger" toggle={this.toggle}>
        {this.state.open && <div ref={this.componentRef} className="w-100">
          <PopoverHeader>
            Notifications
          </PopoverHeader>
          <PopoverBody className="py-0">
            <div className="notification-list" ref={this.listRef}>
              { notificationsStore.notifications.map((notification, index) => <div className={`${index > 0 ? "border-top" : ""}`}>
                  {this.notificationContent(notification)}
                </div>
              )}
              <Waypoint onEnter={() => this.loadMore()} bottomOffset={-20} />
              { notificationsStore.isLoading ? <Spinner center={true} size={'md'} /> : ''}
              { !notificationsStore.notifications.length && <span>No Notifications</span> }
            </div>
          </PopoverBody>
          <div className="notification-popover-footer d-none">
            <a href="/#/workflow2/">View All Notifications</a>
          </div>
        </div>}
      </Popover>
    </div>
  }

  notificationContent(notification) {
    const formatted = formatNotification(notification)
    if (!formatted) return ''
    return <a href={formatted.link} key={notification._id} onClick={() => this.closeList()} className={"notification-item dropdown-item" + (notification.viewed ? '' : 'new')} style={{whiteSpace: "normal"}}>
      <div className="notification-description">{formatted.detail}</div>
      <span className="notification-timestamp"><i className="far fa-clock"></i> {notification.date.fromNow()}</span>
    </a>
  }

  loadMore() {
    notificationsStore.loadMore()
  }
  //TODO - remove style toggle when refactor is complete
  closeList() {
    notificationsStore.markAllViewed();
    this.setState({open: false});
  }

  openList() {
    if (notificationsStore.notifications.length == 0) {
      return // TODO: make a nice style for the empty version
    }
    this.setState({open: true});
  }

});

WorkflowNotificationList.propTypes = propTypes

export default new WorkflowNotificationList()
